// Copyright (c) Microsoft Corporation.
// Licensed under the MIT License.

import ISimpleReference from "../core/ISimpleReference";

export const DamageCause: ISimpleReference[] = [
  { id: "anvil" },
  { id: "block_explosion" },
  { id: "charging" },
  { id: "contact" },
  { id: "drowning" },
  { id: "entity_attack" },
  { id: "entity_explosion" },
  { id: "fall" },
  { id: "falling_block" },
  { id: "fire" },
  { id: "fire_tick" },
  { id: "fireworks" },
  { id: "fly_into_wall" },
  { id: "freezing" },
  { id: "lava" },
  { id: "lightning" },
  { id: "magic" },
  { id: "magma" },
  { id: "none" },
  { id: "override" },
  { id: "piston" },
  { id: "projectile" },
  { id: "stalactite" },
  { id: "stalagmite" },
  { id: "starve" },
  { id: "suffocation" },
  { id: "suicide" },
  { id: "temperature" },
  { id: "thorns" },
  { id: "void" },
  { id: "wither" },
];
